<template>
  <b-card header="Client Referrals" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div class="row">
      <div v-if="!e_add_referral" class="col-12">
        <div class="row">
          <div v-if="notEmptyObject(referral_rebate) && !notEmptyObject(referral_rebate.referrals)" class="col-12">
            <p class="font-weight-bold pt-0 mb-3">Client Does not have any referrals</p>
            <button @click="edit_form" v-if="isAdminManagerUser" class="btn orcaBtn mb-3" :disabled="getting_referrals">
              <span v-if="getting_referrals" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Getting Referrals ...</span>
              <span v-else>Add referral</span>
            </button>
          </div>
          <div v-else class="col-12">
            <div class="row">
              <div class="col-xl-6" v-for="referral in referral_rebate.referrals">
                <div class="referrals clearfix">
                  <div class="referral_text">
                    <h4 class="font-weight-bold bp_color mb-2">{{ return_referral_company_name(referral) }}</h4>
                    <div>
                      <span style="width: 130px;" class="d-inline-block font-weight-bold">Referral Start Date:</span><span>{{ return_referral_start_date(referral) }}</span>
                    </div>
                    <div>
                      <span style="width: 130px;" class="d-inline-block font-weight-bold">Referral End Date:</span><span>{{ return_referral_end_date(referral) }}</span>
                    </div>
                  </div>
                  <div class="referral_cost">
                    <span class="font-weight-bold b2_color d-block" style="font-size: 1.6rem;">{{ return_referral_amount_per_payrolled_worker(referral) }}</span>
                    <div class="b3_color" style="line-height: 1.2;"><span class="d-block">PER PAYROLLED</span><span class="d-block">WORKER</span></div>
                  </div>
                  <button @click.prevent="cancel_referral(referral.id, referral.referred_company.company_name)" v-if="isAdminManagerUser"
                          class="btn orcaBtn sm_btn danger mt-2 float-right">Cancel Referral
                  </button>
                </div>
              </div>
            </div>
            <button @click="edit_form" v-if="isAdminManagerUser" class="btn orcaBtn mb-3 sm_btn w-100" :disabled="getting_referrals">
              <span v-if="getting_referrals" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Getting Referrals ...</span>
              <span v-else>Add referral</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="e_add_referral" class="col-12">
        <ValidationObserver ref="editAddReferralForm" slim>
          <form role="form" @submit.prevent="submit_form">
            <div class="row">
              <!-- Client to refer -->
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Client to refer " tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit_referred_client">Client Referred</label>
                <multiselect v-model="edit_referrals.referrals.referred_company" id="edit_referred_client" name="edit_referred_client" placeholder=""
                             :options="ms_opts.client_list" label="company_name" :class="classes"></multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Rebate Amount per payrolled worker -->
              <ValidationProvider rules="required|decimal" v-slot="{errors, classes}" name="Rebate Amount per payrolled worker" tag="div"
                                  class="col-xl-6 form-group">
                <label class="form-label" for="edit2_amount_per_payrolled_worker">Rebate Amount per payrolled worker</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <input type="text" v-model="edit_referrals.referrals.amount_per_payrolled_worker" id="edit2_amount_per_payrolled_worker"
                         name="edit2_amount_per_payrolled_worker" class="form-input" :class="classes">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Referral start date -->
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Referral start date" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit2_referral_start_date">Referral start date</label>
                <datepicker v-model="edit_referrals.referrals.referral_start_date" id="edit2_referral_start_date" name="edit2_referral_start_date"
                            :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                            clear-button-icon="far fa-calendar-times" @input="select_referral_start_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Referral end date -->
              <ValidationProvider rules="" v-slot="{errors, classes}" name="Referral end date" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit2_referral_end_date">Referral end date</label>
                <datepicker v-model="edit_referrals.referrals.referral_end_date" id="edit2_referral_end_date" name="edit2_referral_end_date"
                            :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                            clear-button-icon="far fa-calendar-times" @input="select_referral_end_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
            <div class="row mb-3">
              <div class="col-xl-6">
                <button @click.prevent="cancel_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
              </div>
              <div class="col-xl-6">
                <button type="submit" class="btn orcaBtn sm_btn w-100">add referral</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "company_referrals",
  components: {
    Multiselect,
    Datepicker
  },
  props: [
    'referral_rebate',
    'isAdminManagerUser',
      'company'
  ],
  data() {
    return {
      e_add_referral: false,
      getting_referrals: false,
      edit_referrals: {},
      ms_opts: {
        client_list: [],
      }
    }
  },
  computed: {},
  methods: {
    /**
     * Cancel a referral set up against this company record
     * @param referral_id
     * @param client_name
     */
    cancel_referral(referral_id, client_name) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Cancel Referral</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you want to cancel the referral for:<br><br>' + client_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'company/referral_rebate/' + referral_id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$bus.$emit('company_referral::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    /**
     * Switch vue to show form to edit company referrals information
     * and set values on form
     */
    edit_form() {
      this.edit_referrals.referrals = Object.assign({}, {
        company_id: this.company.id,
        referred_company_id: '',
        referred_client: null,
        amount_per_payrolled_worker: '',
        referral_start_date: null,
        referral_end_date: null,

        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      })
      this.getting_referrals = true
      axios.get(this.crmApiPath + 'company/referral_rebate/company/' + this.company.id + '/available_referrals')
           .then(not_referred_clients => {
             this.ms_opts.client_list = not_referred_clients.data;
             this.getting_referrals = false;
             this.$nextTick(() => this.e_add_referral = true);
           });
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_referrals.referrals = {}
      this.e_add_referral = false;
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editAddReferralForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editAddReferralForm);
        }
        else {
          this.edit_referrals.referrals.referred_company_id = this.edit_referrals.referrals.referred_company.id;
          this.edit_referrals.referrals.log_by_type = 'App\\Models\\Users\\User';
          this.edit_referrals.referrals.log_by_id = this.$store.state.auth.me.id;

          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);

          axios.post(this.crmApiPath + 'company/referral_rebate', this.edit_referrals.referrals).then(() => {
            this.$bus.$emit('company_referral::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // this.check_referrals();
            // close form
            this.$nextTick(() => {
              this.e_add_referral = false;
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            })
          });
        }
      });
    },
    /* ---------------------------------------------------------------------------------------------------------
     * view data
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Return the company name of a referral set up for this company record
     * @param referral
     * @returns {*}
     */
    return_referral_company_name(referral) {
      return referral.referred_company.company_name
    },
    /**
     * return referral formatted start date
     * @param referral
     * @returns {*}
     */
    return_referral_start_date(referral) {
      return this.$options.filters.formatDate(referral.referral_start_date)
    },
    /**
     * return referral formatted end date
     * OR if no end date then the string "No End Date"
     * @param referral
     * @returns {string|*}
     */
    return_referral_end_date(referral) {
      if (referral.referral_end_date !== null) {
        return this.$options.filters.formatDate(referral.referral_end_date)
      }
      else return "No End Date"
    },
    /**
     * return referral formatted amount per payrolled worker
     * @param referral
     * @returns {*}
     */
    return_referral_amount_per_payrolled_worker(referral) {
      return this.$options.filters.currency(referral.amount_per_payrolled_worker)
    },
    /* ---------------------------------------------------------------------------------------------------------
     * edit form
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Return selected date formatted for datepicker
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Format date for edit values when selected in the start date datepicker
     * @param date
     */
    select_referral_start_date(date) {
      if (date !== null) {
        this.edit_referrals.referrals.referral_start_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    /**
     * Format date for edit values when selected in the end date datepicker
     * @param date
     */
    select_referral_end_date(date) {
      if (date !== null) {
        this.edit_referrals.referrals.referral_end_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
  }
}
</script>

<style scoped lang="scss">

.referrals {
  margin-bottom: 15px;
  background:    #ececec;
  padding:       7.5px;

  .referral_text {
    display:        inline-block;
    width:          calc(100% - 124px);
    vertical-align: middle;
  }

  .referral_cost {
    display:        inline-block;
    width:          120px;
    text-align:     center;
    background:     lighten($bc_5, 10%);
    vertical-align: middle;
    padding-bottom: 5px;
  }
}
</style>
